import { useGetUserEventHistory } from "@/api/admin/useGetUserEventHistory";
import { Loader, Stack, Table, Text } from "@mantine/core";
import dayjs from "dayjs";

interface UserEventHistoryProps {
  userId: string;
}

export const UserEventHistory = ({ userId }: UserEventHistoryProps) => {
  const { data, isLoading } = useGetUserEventHistory(userId, true);

  if (isLoading) {
    return <Loader size="sm" />;
  }

  if (!data?.history || data.history.length === 0) {
    return (
      <Text c="dimmed" size="sm">
        이벤트 참석 이력이 없습니다
      </Text>
    );
  }

  return (
    <Stack gap="xs">
      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ color: "black" }}>날짜</Table.Th>
            <Table.Th style={{ color: "black" }}>레스토랑 (점수)</Table.Th>
            <Table.Th style={{ color: "black" }}>애프터 (점수)</Table.Th>
            <Table.Th style={{ color: "black" }}>결제</Table.Th>
            <Table.Th style={{ color: "black" }}>참석</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {data.history.map((item) => (
            <Table.Tr key={item.eventId}>
              <Table.Td style={{ color: "black" }}>
                {dayjs(item.eventDate).format("YY.MM.DD")}
              </Table.Td>
              <Table.Td style={{ color: "black" }}>
                {item.restaurantName
                  ? `${item.restaurantName} (${item.restaurantScore ?? "-"})`
                  : "-"}
              </Table.Td>
              <Table.Td style={{ color: "black" }}>
                {item.afterPartyName
                  ? `${item.afterPartyName} (${item.afterLocationScore ?? "-"})`
                  : "-"}
              </Table.Td>
              <Table.Td style={{ color: "black" }}>{item.paymentStatus ?? "-"}</Table.Td>
              <Table.Td style={{ color: "black" }}>{item.attendanceStatus ?? "-"}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  );
};
